module.exports = Promise.all([
    import("utils/translator"),
    import("flash-message"),
    import("tap-modal/tap-modal"),
    import("angular"),
    import("selectize"),
]).then(deps => {
    let [Translator, showFlash, showModal, angular] = deps;
    showModal = showModal.default;
    showFlash = showFlash.default;

    var app = angular.module("tapAssetManager");

    app.controller("manageViewCtrl", [
        "$scope",
        "$filter",
        "assetPatcher",
        "$compile",
        "$sce",
        "sharerTwitter",
        function($scope, $filter, assetPatcher, $compile, $sce, sharerTwitter) {
            "use strict";

            $scope.selectDropdown = {
                items: [
                    {
                        title: Translator.trans("general.select.all"),
                        action: function() {
                            angular.forEach($scope.assets, function(asset) {
                                if (!$scope.isHidden(asset)) {
                                    asset.checked = true;
                                }
                            });
                        },
                    },
                    {
                        title: Translator.trans("general.select.none"),
                        action: function() {
                            angular.forEach($scope.assets, function(asset) {
                                asset.checked = false;
                            });
                        },
                    },
                ],
                emptyContent: '<input type="checkbox" disabled="disabled" />',
            };

            $scope.typeDropdown = {
                items: [
                    {
                        title: Translator.trans("general.all"),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = false;
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.banner", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "image_banner" && asset.type !== "html5_banner";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.text_link", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "text_link";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.feed", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "feed";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.video", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "youtube_video" && asset.type !== "vimeo_video";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.social_post", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "facebook_post" && asset.type !== "tweet";
                            });
                        },
                    },
                ],
                emptyContent:
                    '<span class="tapicon tapicon-filter"></span> Filter by type{{ (selected) ? ": " + selected : "" }}',
            };

            $scope.labelDropdown = {
                content:
                    '<div class="padded" ng-click="$event.stopPropagation()"><label>Labels</label><input type="text" class="form-control d-n input-sm" ng-model="data.array" selectize ng-change="itemClicked(data)" placeholder="Type in a label to filter" /></div>',
                action: function(item) {
                    angular.forEach($scope.assets, function(asset) {
                        if (!item.data.array || item.data.array.length === 0) {
                            asset.labelHidden = false;
                            return;
                        }

                        angular.forEach(item.data.array, function(label) {
                            asset.labelHidden = asset.labels.indexOf(label) === -1;
                        });
                    });
                },
                emptyContent:
                    '<span class="tapicon tapicon-filter"></span> Filter by label{{ (selected) ? ": " + selected.length : "" }}',
            };

            $scope.actionsDropdown = {
                items: [
                    {
                        title: "Delete",
                        action: function() {
                            var selectedCount = $scope.getSelectedCount();
                            var title = "Are you sure?";
                            var content =
                                "Are you sure you want to delete " +
                                selectedCount +
                                (selectedCount > 1 ? " assets?" : " asset?");

                            var buttons = [
                                {
                                    text: "Delete",
                                    classes: "btn btn-danger will-load",
                                    attr: {
                                        "data-dismiss": false,
                                    },
                                    callback: function($dialog) {
                                        $dialog.find(".will-load").addClass("loading");
                                        $dialog.find(".btn").prop("disabled", true);

                                        var assets = $filter("filter")($scope.assets, isActionable);
                                        assetPatcher.remove(assets, function(err) {
                                            var message =
                                                assets.length + " asset" + (assets.length > 1 ? "s" : "") + " removed";
                                            $dialog.modal("hide");
                                            showFlash("success", message);
                                        });
                                    },
                                },
                                {
                                    text: "Cancel",
                                },
                            ];

                            showModal(title, content, null, buttons);
                        },
                    },
                    {
                        title: "Update landing page url",
                        action: function() {
                            var title = "Change landing page url";
                            var content = $compile(
                                '<div merge-tags="landingPageUrlTags"><input type="url" class="form-control" placeholder="Example: https://yoursite.com" required /></div><span class="help-block danger regular-fs"></span>',
                            )($scope);

                            var buttons = [
                                {
                                    text: "Save",
                                    classes: "btn btn-success will-load",
                                    attr: {
                                        "data-dismiss": false,
                                    },
                                    callback: function($dialog) {
                                        $dialog.find(".will-load").addClass("loading");
                                        $dialog.find(".btn").prop("disabled", true);

                                        var url = $dialog.find("input").val();
                                        var assets = $filter("filter")($scope.assets, isActionable);

                                        assetPatcher.replace(assets, "landing-page-url", url, function(err, results) {
                                            if (!err && results) {
                                                var errors = assetPatcher.getErrors(results);

                                                $dialog.find(".will-load").removeClass("loading");
                                                $dialog.find(".btn").prop("disabled", false);

                                                if (errors) {
                                                    $dialog.find(".help-block").html(errors[0].replace(/\n/g, "<br>"));
                                                } else {
                                                    angular.forEach(assets, function(editedAsset) {
                                                        angular.forEach($scope.assets, function(asset) {
                                                            if (asset.id === editedAsset.id)
                                                                asset["landing_page_url"] = url;
                                                        });
                                                    });

                                                    $dialog.modal("hide");
                                                }
                                            }
                                        });
                                    },
                                },
                                {
                                    text: "Cancel",
                                },
                            ];

                            showModal(title, content, null, buttons);
                        },
                    },
                    {
                        title: "Add labels",
                        action: function() {
                            var title = "Add labels";
                            var content = $compile(
                                '<input type="text" class="form-control input-sm" id="bulk-label-add" placeholder="Type to add labels" required /><span class="help-block danger regular-fs"></span>',
                            )($scope);

                            var buttons = [
                                {
                                    text: "Add",
                                    classes: "btn btn-success will-load",
                                    attr: {
                                        "data-dismiss": false,
                                    },
                                    callback: function($dialog) {
                                        $dialog.find(".will-load").addClass("loading");
                                        $dialog.find(".btn").prop("disabled", true);

                                        var labels = $dialog
                                            .find("input")
                                            .val()
                                            .split(",");
                                        var assets = $filter("filter")($scope.assets, isActionable);

                                        assetPatcher.add(assets, "labels", labels, function(err, results) {
                                            if (!err && results) {
                                                var errors = assetPatcher.getErrors(results);

                                                $dialog.find(".will-load").removeClass("loading");
                                                $dialog.find(".btn").prop("disabled", false);

                                                if (errors) {
                                                    $dialog.find(".help-block").html(errors[0].replace(/\n/g, "<br>"));
                                                } else {
                                                    angular.forEach(assets, function(editedAsset) {
                                                        angular.forEach($scope.assets, function(asset) {
                                                            if (asset.id === editedAsset.id) {
                                                                angular.forEach(labels, function(label) {
                                                                    if (asset.labels.indexOf(label) === -1)
                                                                        asset.labels.push(label.toLowerCase());
                                                                });
                                                            }
                                                        });
                                                    });

                                                    $dialog.modal("hide");
                                                }
                                            }
                                        });
                                    },
                                },
                                {
                                    text: "Cancel",
                                },
                            ];

                            var callbacks = {
                                "shown.bs.modal": function() {
                                    $("#bulk-label-add").selectize({
                                        delimiter: ",",
                                        persist: false,
                                        plugins: ["remove_button"],
                                        create: function(input) {
                                            return {
                                                value: input.toLowerCase(),
                                                text: input.toLowerCase(),
                                            };
                                        },
                                    });
                                },
                            };

                            showModal(title, content, callbacks, buttons);
                        },
                    },
                ],
                emptyContent: '<span class="tapicon tapicon-play"></span> Actions',
            };

            var isActionable = function(asset) {
                return asset.checked && !asset.labelHidden && !asset.typeHidden;
            };

            $scope.isHidden = function(asset) {
                return asset.labelHidden || asset.typeHidden;
            };

            $scope.getSelectedCount = function() {
                var count = 0;
                angular.forEach($scope.assets, function(asset) {
                    if (isActionable(asset)) count++;
                });

                return count;
            };

            $scope.getTrustedUrl = function(url) {
                return $sce.trustAsResourceUrl(url);
            };

            $scope.updateLandingPageUrl = function(asset, cb) {
                asset.isUpdating = true;
                assetPatcher.replace(asset, "landing-page-url", asset["landing_page_url"], function(err, results) {
                    if (!err && results) {
                        var errors = assetPatcher.getErrors(results);
                        cb(errors);
                    }
                    asset.isUpdating = false;
                });
            };

            $scope.updateContent = function(asset, cb) {
                asset.isUpdating = true;
                assetPatcher.replace(asset, "content", asset.content, function(err, results) {
                    if (!err && results) {
                        var errors = assetPatcher.getErrors(results);
                        cb(errors);
                    }
                    asset.isUpdating = false;
                });
            };

            $scope.updateLabels = function(asset, cb) {
                asset.isUpdating = true;

                assetPatcher.replace(asset, "labels", asset.labels, function(err, results) {
                    if (!err && results) {
                        var errors = assetPatcher.getErrors(results);
                        cb(errors);
                    }
                    asset.isUpdating = false;
                });
            };

            $scope.showFeedErrorDialog = function(errors) {
                var content = '<table class="error-table">';
                angular.forEach(errors, function(error, index) {
                    content +=
                        "<tr><td><h4>Error #" +
                        (index + 1) +
                        '</h4></td></tr><tr><td><table class="table table-condensed">';

                    angular.forEach(error, function(value, key) {
                        content +=
                            "<tr><td>" +
                            (key == "id" ? "Item Id" : $filter("capitalize")(key)) +
                            "</td><td>" +
                            value +
                            "</td></tr>";
                    });

                    content += "</table></td></tr>";
                });

                content += "</table>";

                var title = errors.length === 100 ? "Errors (Showing first 100)" : "Errors";

                showModal(title, content, null, [{}]);
            };

            $scope.isFiltered = function() {
                var hidden = $filter("filter")($scope.assets, function(asset) {
                    return $scope.isHidden(asset);
                });

                return hidden.length > 0;
            };

            $scope.visibleAssetCount = function() {
                var visible = $filter("filter")($scope.assets, function(asset) {
                    return !$scope.isHidden(asset);
                });

                return visible.length;
            };

            $scope.$watch(
                "[assets, splitViewVars.selectedItem]",
                function(newValue) {
                    $scope.splitViewVars.noView =
                        newValue[0].length === 0 && $scope.isSelectedItem($scope.masterItems[0]);
                    $scope.$emit("viewstackPosition");
                },
                true,
            );

            $scope.isTweetWithinMaxCharacters = function(content) {
                var maxCharacters = 280 - 1 - sharerTwitter.shortUrlLength;

                return (content ? content.length : 0) <= maxCharacters;
            };
        },
    ]);
});
